module.exports = __webpack_public_path__ + "img/characterAnime21.a2a757e8.png";